import { GameLayers } from '../../core/enums';

class GameLayersService {
  constructor() {
    this._layers = {};
  }

  get layers() {
    return this._layers;
  }

  set layers(value) {
    this._layers = value;
  }

  hide(name) {
    this.layers[name].visible = false;
  }

  show(name) {
    this.layers[name].visible = true;
  }

  showDragonSoul() {
    this.show(GameLayers.dragonSoulSpine);
  }

  hideDragonSoul() {
    this.hide(GameLayers.dragonSoulSpine);
  }

  showGamePad() {
    this.show(GameLayers.gamePad);
  }

  hideGamePad() {
    this.hide(GameLayers.gamePad);
  }

  showBonusBoard() {
    this.show(GameLayers.bonusBoard);
  }

  hideBonusBoard() {
    this.hide(GameLayers.bonusBoard);
  }

  showBackgroundPlate() {
    this.show(GameLayers.plateSpine);
  }

  hideBackgroundPlate() {
    this.hide(GameLayers.plateSpine);
  }
}

export const gameLayers = new GameLayersService();
